module.exports = __webpack_public_path__ + "media/components/assets/icons/heart_fill-142286593d289fd1e82302f97cc08437.svg";